'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestCorrespondent() {
}
export { $c_Lapp_api_DrugRequestCorrespondent as $c_Lapp_api_DrugRequestCorrespondent };
$c_Lapp_api_DrugRequestCorrespondent.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestCorrespondent.prototype.constructor = $c_Lapp_api_DrugRequestCorrespondent;
/** @constructor */
function $h_Lapp_api_DrugRequestCorrespondent() {
}
export { $h_Lapp_api_DrugRequestCorrespondent as $h_Lapp_api_DrugRequestCorrespondent };
$h_Lapp_api_DrugRequestCorrespondent.prototype = $c_Lapp_api_DrugRequestCorrespondent.prototype;
$c_Lapp_api_DrugRequestCorrespondent.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.api.-Drug-Request-Correspondent.js.map
